import React from 'react';

const B2BManagement = () => {
  return (
    <div className="b2b-management">
      <div className="page-header">
        <h2>B2B Yönetimi</h2>
        <p>B2B portal yönetimini yapın</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default B2BManagement; 